import axios from 'axios';

import {
  axiosHeader,
  publicAxiosHeader,
  getV1RootUrl
} from 'common/helpers/apiHelper';

export const listClubMemberships = (customerId, queryString) => {
  if (queryString) {
    return axios.get(
      `${getV1RootUrl()}/customer/${customerId}/club-membership?populate=nextClubShipment&${queryString}`,
      axiosHeader()
    );
  }
  return axios.get(
    `${getV1RootUrl()}/customer/${customerId}/club-membership?populate=nextClubShipment`,
    axiosHeader()
  );
};

export const getClubMembership = (clubMembershipId) =>
  axios.get(
    `${getV1RootUrl()}/club-membership/${clubMembershipId}/limited?populate=nextClubShipment,shipTo,pickupAt,customerCreditCard,billTo`,
    publicAxiosHeader()
  );

export const editClubMembership = (customerId, clubMembershipId, data) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}`,
    data,
    axiosHeader()
  );

export const cancelClubMembership = (customerId, clubMembershipId, data) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/cancel`,
    data,
    axiosHeader()
  );

export const addClubMembershipHold = (customerId, clubMembershipId, data) =>
  axios.post(
    `${getV1RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/on-hold`,
    data,
    axiosHeader()
  );

export const editClubMembershipHold = (
  customerId,
  clubMembershipId,
  id,
  data
) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/on-hold/${id}`,
    data,
    axiosHeader()
  );
